import z from 'zod';

export const procedureDataSchema = z.object({
  id: z.string().uuid({ message: 'Invalid procedure ID format' }),
  displayName: z.string(),
  name: z.string(),
  price: z.number(),
  category: z.string(),
});

export type ProcedureData = z.infer<typeof procedureDataSchema>;
